import { useMemo } from 'react';
import useTabsStore from 'src/store/tabs';
import { TabType } from 'src/utils/hooks/use-global-tabs';

export interface OpenConversationEntry {
  id: string;
  conversationId: string;
  friendlyId: string;
  partnerId: number;
}

export const useOpenConversationTabs = (partnerId: number | null): OpenConversationEntry[] => {
  const tabs = useTabsStore((state) => state.tabs);

  return useMemo(() => {
    const entries: OpenConversationEntry[] = [];
    tabs.forEach((tab) => {
      if (tab.type !== TabType.Conversation || tab.partnerId !== partnerId) {
        return;
      }
      const { id, conversationId, friendlyId, partnerId: entityPartnerId } = tab.entity;
      entries.push({ id, conversationId, friendlyId, partnerId: entityPartnerId });
    });
    return entries;
  }, [tabs, partnerId]);
};
